export default __webpack_public_path__ + "static/media/AFG.3b1e9919.svg";